/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeclineShiftCoverRequest} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'
import {DeclineShiftCoverResponse} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'


export const declineShiftCover = (request: DeclineShiftCoverRequest, options?: CashRequestOptions) => post<DeclineShiftCoverRequest, DeclineShiftCoverResponse>("/2.0/cash/decline-shift-cover", request, {...options, rejectOnError: true })